import { render, staticRenderFns } from "./EmailConversation.vue?vue&type=template&id=54a8c736&scoped=true"
import script from "./EmailConversation.vue?vue&type=script&lang=js"
export * from "./EmailConversation.vue?vue&type=script&lang=js"
import style0 from "./EmailConversation.vue?vue&type=style&index=0&id=54a8c736&prod&lang=scss&scoped=true"
import style1 from "./EmailConversation.vue?vue&type=style&index=1&id=54a8c736&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a8c736",
  null
  
)

export default component.exports